import React from "react";

const DesignMain = () => {
  return <div>DesignMain</div>;
};

export default DesignMain;
